import React from 'react';
import { generatePlatformSettingsTabs } from '../platformSettingsTabUtils';

export const COMPANY_PAGE_TAB_GROUP_ID = 'company-page';

const COMPANY_PAGE_TAB_COMPONENTS_BY_ID = {
  video: React.lazy(() => import('./Video/IntroVideoSettings')),
  about: React.lazy(() => import('./About/AboutSettings')),
  milestones: React.lazy(() => import('./Milestones/MilestonesContent')),
  values: React.lazy(() => import('./Values/CompanyValuesSettingsTab')),
  gallery: React.lazy(() => import('./Gallery/Gallery')),
};

export const COMPANY_PAGE_TABS = generatePlatformSettingsTabs(
  COMPANY_PAGE_TAB_COMPONENTS_BY_ID,
  COMPANY_PAGE_TAB_GROUP_ID,
);
